import { render } from "./Cutouts.vue?vue&type=template&id=58edb09b"
import script from "./Cutouts.vue?vue&type=script&lang=js"
export * from "./Cutouts.vue?vue&type=script&lang=js"

import exportComponent from "C:\\NicolPC\\VueWork2026\\Axxo\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__